<!-- Loading state-->
<div *ngIf="loading" class="cdp-grid-loading cdp-fade-in">
    <hc-progress-spinner [diameter]="64" [color]="'blue'"></hc-progress-spinner>
</div>

<!-- Fail state -->
<div *ngIf="!loading && loadFailed" class="cdp-grid-empty cdp-fade-in">
    <span class="icon-warn cdp-grid-empty-ico"></span>
    <p>{{ nameSingular ? 'Unable to load the ' + nameSingular + ' list.' : 'Unable to load' }}</p>
    <a hc-button buttonStyle="link-inline" (click)="refresh.emit()"
        ><span class="icon-left icon-refresh"></span>Try again</a
    >
</div>

<!-- Empty state -->
<div *ngIf="!loading && !loadFailed && !hasFilterMatchData" class="cdp-grid-empty cdp-fade-in">
    <!-- Empty via search or filters -->
    <ng-container *ngIf="hasData">
        <span class="icon-folder-open cdp-grid-empty-ico"></span>
        <p>Nothing to show.</p>
        <a *ngIf="searchValue?.length > 0" hc-button buttonStyle="link-inline" (click)="clearSearch.emit()">
            <span class="icon-left icon-refresh"></span>
            Clear search
        </a>
    </ng-container>

    <!-- No data -->
    <ng-container *ngIf="!hasData">
        <span class="icon-folder-open cdp-grid-empty-ico"></span>
        <p *ngIf="emptyMsg">{{ emptyMsg }}</p>
        <p *ngIf="!emptyMsg">No {{ namePlural }} to show. {{ allowAddNew ? 'Add one now?' : '' }}</p>
        <a
            *ngIf="allowAddNew && addButtonText === ''"
            hc-button
            [buttonStyle]="addButtonStyle"
            (click)="createNew.emit()"
        >
            <span class="icon-left icon-add"></span>{{ nameSingular ? 'New ' + nameSingular : 'Create new' }}
        </a>
        <a
            *ngIf="allowAddNew && addButtonText !== ''"
            hc-button
            [buttonStyle]="addButtonStyle"
            (click)="createNew.emit()"
        >
            <span [class]="'icon-left ' + addButtonIcon"></span>{{ addButtonText }}
        </a>
    </ng-container>
</div>

<!-- No columns -->
<div
    *ngIf="!loading && !loadFailed && hasFilterMatchData && hasEditableCols && noColsSelected"
    class="cdp-grid-empty cdp-fade-in"
>
    <span class="icon-folder-open cdp-grid-empty-ico"></span>
    <p>Nothing to show. Need to select columns.</p>
    <a hc-button buttonStyle="link" (click)="selectCols.emit()">
        <span class="icon-left icon-table-cog cdp-ico-lg"></span>Select columns
    </a>
</div>
